"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudienceSelectorsButtons = void 0;
var _AudienceSelectorsButtons = require("./AudienceSelectorsButtons.styles");
var _Button = require("../../../../../UI/Button");
var _hooks = require("../../../../../hooks");
var _AudiencePicker = require("../../../AudiencePicker.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var AudienceSelectorsButtons = function AudienceSelectorsButtons(props) {
  var selectedClassesIds = props.selectedClassesIds,
    selectedGroupsIds = props.selectedGroupsIds,
    selectedStudentsIds = props.selectedStudentsIds,
    setGroupsSelectorTempData = props.setGroupsSelectorTempData,
    setStudentsSelectorTempData = props.setStudentsSelectorTempData,
    setViewAndIndex = props.setViewAndIndex,
    environmentID = props.environmentID,
    classesIds = props.classesIds,
    groupsIds = props.groupsIds;
  var styles = (0, _AudienceSelectorsButtons.useStyles)(props);
  var getLabel = (0, _hooks.useLabels)({
    labels: _AudiencePicker.labels
  });
  var handleClassesAndGroupsClick = function handleClassesAndGroupsClick() {
    setGroupsSelectorTempData({
      selectedGroupsIds: _toConsumableArray(selectedGroupsIds || []),
      selectedClassesIds: _toConsumableArray(selectedClassesIds || [])
    });
    setViewAndIndex('groupsSelector', 0);
  };
  var handleStudentsClick = function handleStudentsClick() {
    setStudentsSelectorTempData({
      selectedStudentsIds: _toConsumableArray(selectedStudentsIds || []),
      groupSearchText: '',
      isGroupSearchOpen: false,
      studentsSearchText: '',
      isStudentsSearchOpen: false,
      selectedGroup: environmentID ? 'all' : classesIds && classesIds.length > 0 ? classesIds[0] : groupsIds && groupsIds.length > 0 ? groupsIds[0] : ''
    });
    setViewAndIndex('studentsSelector', 0);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__audience-selectors-buttons'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.Button, {
      view: "outlined",
      color: "basic",
      shape: "roundedRectangle",
      customStyle: {
        width: '50%'
      },
      onClick: handleClassesAndGroupsClick,
      children: [getLabel('inlineTools_groupsSelector_class'), ' ', selectedClassesIds && selectedClassesIds.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-AudiencePicker__audience-selectors-buttons__count'],
        children: ["(", selectedClassesIds === null || selectedClassesIds === void 0 ? void 0 : selectedClassesIds.length, ")"]
      }), getLabel('inlineTools_groupsSelector_groups'), selectedGroupsIds && (selectedGroupsIds === null || selectedGroupsIds === void 0 ? void 0 : selectedGroupsIds.length) > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-AudiencePicker__audience-selectors-buttons__count'],
        children: ["(", selectedGroupsIds.length, ")"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.Button, {
      view: "outlined",
      color: "basic",
      shape: "roundedRectangle",
      customStyle: {
        width: '50%'
      },
      onClick: handleStudentsClick,
      children: [getLabel('inlineTools_studentsSelector'), ' ', selectedStudentsIds && selectedStudentsIds.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: styles['cc-AudiencePicker__audience-selectors-buttons__count'],
        children: ["(", selectedStudentsIds.length, ")"]
      })]
    })]
  });
};
exports.AudienceSelectorsButtons = AudienceSelectorsButtons;